import React, { Component } from "react";
import { connect } from "react-redux";
import BaseDateField from '../../Base/ui/inputs/DateField'

class DateField extends Component {
  handleChange(date) {
    this.props.handleChange(this.props.name, date ? date.format("YYYY-MM-DD") : null);
  }

  render() {
    const { resource, name, label, col, action, value } = this.props;
    return(
      <BaseDateField 
        resource={resource}
        name={name}
        label={label}
        col={col}
        value={value}
        action={action}
        onChange={this.handleChange.bind(this)}/>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { resource = "resident", name } = ownProps;

  return {
    resource: resource,
    value: state[resource][name],
    action: ownProps.action || state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (name, value) => dispatch({ type: "UPDATE_RESIDENT", payload: { name, value }})
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DateField);
